/**
 * Freedom Mobile Menu Toggle
 * Handles hamburger menu button click to open/close mobile menu drawer
 * Left-side sliding drawer with overlay
 */

(function() {
  'use strict';

  let isOpen = false;

  function openMenu() {
    const drawer = document.getElementById('freedom-mobile-menu-drawer');
    const toggles = document.querySelectorAll('.freedom-mobile-menu-toggle');

    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('freedom-menu-open');

    if (window.innerWidth >= 990) {
      drawer.classList.add('freedom-mobile-menu-drawer--from-desktop');
    } else {
      drawer.classList.remove('freedom-mobile-menu-drawer--from-desktop');
    }

    toggles.forEach(function(t) {
      t.setAttribute('aria-expanded', 'true');
      t.classList.add('active');
    });

    isOpen = true;
  }

  function closeMenu() {
    const drawer = document.getElementById('freedom-mobile-menu-drawer');
    const toggles = document.querySelectorAll('.freedom-mobile-menu-toggle');

    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('freedom-mobile-menu-drawer--from-desktop');
    document.body.classList.remove('freedom-menu-open');

    toggles.forEach(function(t) {
      t.setAttribute('aria-expanded', 'false');
      t.classList.remove('active');
    });

    isOpen = false;
  }

  function initMobileMenu() {
    const menuToggles = document.querySelectorAll('.freedom-mobile-menu-toggle');
    const closeButton = document.getElementById('freedom-mobile-menu-close');
    const overlay = document.getElementById('freedom-mobile-menu-overlay');
    const drawer = document.getElementById('freedom-mobile-menu-drawer');

    if (!drawer) return;

    function bindToggle(el) {
      if (!el) return;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (isOpen) closeMenu();
        else openMenu();
      });
      el.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (isOpen) closeMenu();
          else openMenu();
        }
      });
    }

    menuToggles.forEach(bindToggle);

    // Breadcrumb trigger: prevent links inside from navigating so the whole area opens the menu
    document.querySelectorAll('.header-breadcrumb-trigger a').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    // Close menu on X button click
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
      });
    }

    // Close menu on overlay click
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
      });
    }

    // Close menu on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) {
        closeMenu();
      }
    });

    window.addEventListener('resize', function() {
      if (!isOpen || !drawer) return;
      if (window.innerWidth >= 990) {
        drawer.classList.add('freedom-mobile-menu-drawer--from-desktop');
      } else {
        drawer.classList.remove('freedom-mobile-menu-drawer--from-desktop');
      }
    });

    // Close menu when clicking a menu link (optional - allows navigation)
    const menuLinks = drawer.querySelectorAll('.freedom-mobile-menu-drawer__link');
    menuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        // Close after a short delay to allow navigation
        setTimeout(closeMenu, 100);
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }

  // Re-initialize when section reloads (Theme Editor)
  document.addEventListener('shopify:section:load', function(event) {
    const drawer = document.getElementById('freedom-mobile-menu-drawer');
    if (drawer) {
      initMobileMenu();
    }
  });
})();

